import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/css/admin.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Modal from "react-modal";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#f8f9fa",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1000,
    },
};

Modal.setAppElement("#root");

const ReservationAdmin = () => {
    const { t } = useTranslation("admin");
    const [reservations, setReservations] = useState([]);
    const [selectedReservation, setSelectedReservation] = useState(null);
    const navigate = useNavigate();
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [actionToConfirm, setActionToConfirm] = useState(null);
    const [itemToDeleteOrUpdate, setItemToDeleteOrUpdate] = useState(null);
const API_BASE_URL = process.env.REACT_APP_API_URL;
    // Déclarez fetchReservations en dehors de useEffect
    const fetchReservations = async () => {
        try {
            const token = localStorage.getItem("adminToken");
            if (!token) {
                navigate("/connexion");
                return;
            }
            const response = await axios.get(
                `${API_BASE_URL}/api/admin/reservations`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setReservations(response.data);
        } catch (error) {
            console.error(
                "Erreur lors de la récupération des réservations:",
                error
            );
            if (error.response && error.response.status === 401) {
                navigate("/connexion");
            }
        }
    };

    useEffect(() => {
        fetchReservations(); // Appelez fetchReservations au montage du composant
    }, [navigate]);

    const openConfirmationModal = (action, item) => {
        setActionToConfirm(action);
        setItemToDeleteOrUpdate(item);
        setConfirmationModalOpen(true);
    };

    const closeConfirmationModal = () => {
        setActionToConfirm(null);
        setItemToDeleteOrUpdate(null);
        setConfirmationModalOpen(false);
    };

    const handleConfirmAction = async () => {
        if (actionToConfirm === "deleteReservation" && itemToDeleteOrUpdate) {
            await handleDeleteReservation(itemToDeleteOrUpdate);
            fetchReservations(); // Appelez fetchReservations après la suppression
        } else if (
            actionToConfirm === "updateReservationStatus" &&
            itemToDeleteOrUpdate
        ) {
            await handleConfirmUpdateReservationStatus(
                itemToDeleteOrUpdate.id,
                itemToDeleteOrUpdate.status
            );
            fetchReservations(); // Appelez fetchReservations après la mise à jour du statut
        } else if (
            actionToConfirm === "updateReservationValidation" &&
            itemToDeleteOrUpdate
        ) {
            await handleConfirmUpdateReservationValidation(
                itemToDeleteOrUpdate.id,
                itemToDeleteOrUpdate.isValidated
            );
            fetchReservations(); // Appelez fetchReservations après la mise à jour de la validation
        }
        closeConfirmationModal();
    };

    const handleDeleteReservation = async (reservationId) => {
        try {
            const token = localStorage.getItem("adminToken");
            if (!token) {
                navigate("/connexion");
                return;
            }
            await axios.delete(
                `${API_BASE_URL}/api/admin/reservations/${reservationId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setReservations(
                reservations.filter(
                    (reservation) => reservation._id !== reservationId
                )
            );
        } catch (error) {
            console.error(
                "Erreur lors de la suppression de la réservation:",
                error
            );
            if (error.response && error.response.status === 401) {
                navigate("/connexion");
            }
        }
    };

    const openReservationDetails = (reservation) => {
        setSelectedReservation(reservation);
    };

    const closeReservationDetails = () => {
        setSelectedReservation(null);
    };

    const handleUpdateReservationStatus = (reservationId, newStatus) => {
        openConfirmationModal("updateReservationStatus", {
            id: reservationId,
            status: newStatus,
        });
    };

    const handleConfirmUpdateReservationStatus = async (
        reservationId,
        newStatus
    ) => {
        try {
            const token = localStorage.getItem("adminToken");
            if (!token) {
                navigate("/connexion");
                return;
            }
            const response = await axios.put(
                `${API_BASE_URL}/api/admin/reservations/${reservationId}/status`,
                { status: newStatus },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.status === 200) {
                setReservations((prevReservations) =>
                    prevReservations.map((res) =>
                        res._id === reservationId
                            ? { ...res, statut: newStatus }
                            : res
                    )
                );
                console.log(
                    `Statut de la réservation ${reservationId} mis à jour à ${newStatus}`
                );
            } else {
                console.error(
                    "Erreur lors de la mise à jour du statut:",
                    response
                );
                alert(t("update_status_error"));
            }
        } catch (error) {
            console.error(
                "Erreur réseau lors de la mise à jour du statut:",
                error
            );
            alert(t("network_error"));
        }
    };

    const handleUpdateReservationValidation = (reservationId, isValidated) => {
        openConfirmationModal("updateReservationValidation", {
            id: reservationId,
            isValidated: isValidated,
        });
    };

    const handleConfirmUpdateReservationValidation = async (
        reservationId,
        isValidated
    ) => {
        try {
            const token = localStorage.getItem("adminToken");
            if (!token) {
                navigate("/connexion");
                return;
            }
            const response = await axios.put(
                `${API_BASE_URL}/api/admin/reservations/${reservationId}/validate`,
                { est_valide: isValidated },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.status === 200) {
                setReservations((prevReservations) =>
                    prevReservations.map((res) =>
                        res._id === reservationId
                            ? { ...res, est_valide: isValidated }
                            : res
                    )
                );
                console.log(
                    `Validation de la réservation ${reservationId} mise à jour à ${isValidated}`
                );
            } else {
                console.error(
                    "Erreur lors de la mise à jour de la validation:",
                    response
                );
                alert(t("update_validation_error"));
            }
        } catch (error) {
            console.error(
                "Erreur réseau lors de la mise à jour de la validation:",
                error
            );
            alert(t("network_error"));
        }
    };

    const confirmDeleteReservation = (id) => {
        openConfirmationModal("deleteReservation", id);
    };

    return (
        <section className="manage-reservations admin-dashboard">
            <h2>{t("manage_reservations")}</h2>
            {reservations.length > 0 ? (
                <table>
                    <thead>
                        <tr>
                            <th>{t("service")}</th>
                            <th>{t("date")}</th>
                            <th>{t("time")}</th>
                            <th>{t("client_name")}</th>
                            <th>{t("client_email")}</th>
                            <th>{t("lieu_evenement")}</th> {/* Ajout du lieu */}
                            <th>{t("ville_evenement")}</th>{" "}
                            {/* Ajout de la ville */}
                            <th>{t("validation")}</th>
                            <th>{t("status")}</th>
                            <th>{t("actions")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reservations.map((reservation, index) => (
                            <tr key={index}>
                                <td>{reservation.service_demande}</td>
                                <td>
                                    {moment(reservation.date_evenement).format(
                                        "YYYY-MM-DD"
                                    )}
                                </td>
                                <td>{reservation.heure_evenement}</td>
                                <td>{reservation.nom_client}</td>
                                <td>{reservation.email_client}</td>
                                <td>{reservation.lieu_evenement}</td>{" "}
                                {/* Affichage du lieu */}
                                <td>{reservation.ville_evenement}</td>{" "}
                                {/* Affichage de la ville */}
                                <td>
                                    {reservation.est_valide
                                        ? t("validee")
                                        : t("non_validee")}
                                    <button
                                        className="accepadm"
                                        onClick={() =>
                                            handleUpdateReservationValidation(
                                                reservation.id,
                                                !reservation.est_valide
                                            )
                                        }
                                    >
                                        {reservation.est_valide
                                            ? t("invalider")
                                            : t("valider")}
                                    </button>
                                </td>
                                <td>
                                    {reservation.est_valide && (
                                        <select
                                            value={reservation.statut || ""}
                                            onChange={(e) =>
                                                handleUpdateReservationStatus(
                                                    reservation.id,
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="">
                                                {t("select_status")}
                                            </option>
                                            <option value="EN COURS">
                                                {t("en_cours")}
                                            </option>
                                            <option value="FAIT">
                                                {t("fait")}
                                            </option>
                                        </select>
                                    )}
                                    {!reservation.est_valide &&
                                        reservation.statut}
                                </td>
                                <td>
                                    <button
                                        className="accepadm"
                                        onClick={() =>
                                            openReservationDetails(reservation)
                                        }
                                    >
                                        {t("view_details")}
                                    </button>
                                    <button
                                        className="deleteadm"
                                        onClick={() =>
                                            confirmDeleteReservation(
                                                reservation.id
                                            )
                                        }
                                    >
                                        {t("delete_reservation")}
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>{t("no_reservations")}</p>
            )}

            {selectedReservation && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>{t("reservation_details")}</h3>
                        <p>
                            <strong>{t("client_name")}:</strong>{" "}
                            {selectedReservation.nom_client}
                        </p>
                        <p>
                            <strong>{t("client_email")}:</strong>{" "}
                            {selectedReservation.email_client}
                        </p>
                        <p>
                            <strong>{t("client_phone")}:</strong>{" "}
                            {selectedReservation.telephone_client ||
                                t("not_provided")}
                        </p>
                        <p>
                            <strong>{t("service")}:</strong>{" "}
                            {selectedReservation.service_demande}
                        </p>
                        <p>
                            <strong>{t("date")}:</strong>{" "}
                            {moment(selectedReservation.date_evenement).format(
                                "YYYY-MM-DD"
                            )}
                        </p>
                        <p>
                            <strong>{t("time")}:</strong>{" "}
                            {selectedReservation.heure_evenement}
                        </p>
                        <p>
                            <strong>{t("lieu_evenement")}:</strong>{" "}
                            {selectedReservation.lieu_evenement}{" "}
                            {/* Affichage du lieu dans les détails */}
                        </p>
                        <p>
                            <strong>{t("ville_evenement")}:</strong>{" "}
                            {selectedReservation.ville_evenement}{" "}
                            {/* Affichage de la ville dans les détails */}
                        </p>
                        {selectedReservation.type_evenement && (
                            <p>
                                <strong>{t("event_type")}:</strong>{" "}
                                {selectedReservation.type_evenement}
                            </p>
                        )}
                        {selectedReservation.type_menu && (
                            <p>
                                <strong>{t("menu_type")}:</strong>{" "}
                                {selectedReservation.type_menu}
                            </p>
                        )}
                        {selectedReservation.restrictions_alimentaires &&
                            selectedReservation.restrictions_alimentaires
                                .length > 0 && (
                                <p>
                                    <strong>
                                        {t("dietary_restrictions")}:
                                    </strong>{" "}
                                    {selectedReservation.restrictions_alimentaires.join(
                                        ", "
                                    )}
                                </p>
                            )}
                        {selectedReservation.nombre_personnes && (
                            <p>
                                <strong>{t("guest_count")}:</strong>{" "}
                                {selectedReservation.nombre_personnes}
                            </p>
                        )}
                        {selectedReservation.type_viande && (
                            <p>
                                <strong>{t("meat_type")}:</strong>{" "}
                                {selectedReservation.type_viande}
                            </p>
                        )}
                        {selectedReservation.lieu_installation && (
                            <p>
                                <strong>{t("setup_location")}:</strong>{" "}
                                {selectedReservation.lieu_installation}
                            </p>
                        )}
                        {selectedReservation.description_espace && (
                            <p>
                                <strong>{t("space_description")}:</strong>{" "}
                                {selectedReservation.description_espace}
                            </p>
                        )}
                        {selectedReservation.budget !== null &&
                            selectedReservation.budget !== undefined && (
                                <p>
                                    <strong>{t("budget")}:</strong>{" "}
                                    {selectedReservation.budget}
                                </p>
                            )}
                        <p>
                            <strong>{t("additional_requests")}:</strong>{" "}
                            {selectedReservation.demandes_additionnelles ||
                                t("none")}
                        </p>
                        <p>
                            <strong>{t("reception_date")}:</strong>{" "}
                            {moment(selectedReservation.date_reception).format(
                                "YYYY-MM-DD HH:mm:ss"
                            )}
                        </p>
                        <button
                            className="close-modal-button"
                            onClick={closeReservationDetails}
                        >
                            {t("close")}
                        </button>
                    </div>
                </div>
            )}

            {/* Confirmation Modal */}
            <Modal
                isOpen={confirmationModalOpen}
                onRequestClose={closeConfirmationModal}
                style={customStyles}
                contentLabel={t("confirmation_modal_title")}
            >
                <h2>{t("confirmation_modal_title")}</h2>
                <p>
                    {actionToConfirm === "deleteReservation" &&
                        t("confirm_delete_reservation")}
                    {actionToConfirm === "updateReservationStatus" &&
                        t("confirm_update_status")}
                    {actionToConfirm === "updateReservationValidation" &&
                        t("confirm_update_validation")}
                </p>
                <button
                    onClick={handleConfirmAction}
                    className="confirm-button"
                >
                    {t("confirm")}
                </button>
                <button
                    onClick={closeConfirmationModal}
                    className="cancel-button"
                >
                    {t("cancel")}
                </button>
            </Modal>
        </section>
    );
};

export default ReservationAdmin;
